import { render, staticRenderFns } from "./EditSoftware.vue?vue&type=template&id=4f77d3b7&scoped=true&"
import script from "./EditSoftware.vue?vue&type=script&lang=js&"
export * from "./EditSoftware.vue?vue&type=script&lang=js&"
import style0 from "./EditSoftware.vue?vue&type=style&index=0&id=4f77d3b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f77d3b7",
  null
  
)

export default component.exports